"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Radio = exports.RadioGroup = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var R = __importStar(require("../../utils/ramda"));
require("./RadioGroup.css");
var useRandomGuid_1 = require("../../hooks/useRandomGuid");
var Box_1 = require("../../components/Box");
var classnames_1 = __importDefault(require("classnames"));
var Popover_1 = require("../../components/Popover");
var react_dom_1 = require("react-dom");
var Grid_1 = require("../../components/Grid");
var RadioGroup = function (_a) {
  var _b;
  var _c = _a.direction,
    direction = _c === void 0 ? "row" : _c,
    selected = _a.selected,
    setSelected = _a.setSelected,
    children = _a.children,
    className = _a.className,
    _gap = _a.gap,
    _rowGap = _a.rowGap,
    disabled = _a.disabled,
    restProps = __rest(_a, ["direction", "selected", "setSelected", "children", "className", "gap", "rowGap", "disabled"]);
  var ref = (0, react_1.useRef)(null);
  var gap = (_gap !== null && _gap !== void 0 ? _gap : direction === "row") ? "xl" : "medium";
  var rowGap = (_b = _rowGap !== null && _rowGap !== void 0 ? _rowGap : _gap) !== null && _b !== void 0 ? _b : "medium";
  return (0, jsx_runtime_1.jsxs)(Box_1.Box, __assign({
    className: (0, classnames_1.default)("vsx-radio-group", className),
    direction: direction,
    gap: gap,
    rowGap: rowGap,
    wrap: true
  }, restProps, {
    children: [(0, jsx_runtime_1.jsx)(RadioGroupContext.Provider, __assign({
      value: {
        direction: direction,
        disabled: disabled,
        expandedRow: ref.current,
        selected: selected,
        setSelected: setSelected
      }
    }, {
      children: children
    })), direction === "row" ? (0, jsx_runtime_1.jsx)("div", {
      className: "vsx-radio-group-expanded-row",
      ref: ref
    }) : null]
  }));
};
exports.RadioGroup = RadioGroup;
var Radio = function (_a) {
  var value = _a.value,
    children = _a.children,
    _b = _a.disabled,
    disabled = _b === void 0 ? false : _b,
    inputId = _a.inputId,
    tooltip = _a.tooltip,
    details = _a.details,
    expandContent = _a.expandContent,
    _c = _a.tooltipPlacement,
    tooltipPlacement = _c === void 0 ? "top" : _c,
    _d = _a.gap,
    gap = _d === void 0 ? "medium" : _d,
    className = _a.className,
    restProps = __rest(_a, ["value", "children", "disabled", "inputId", "tooltip", "details", "expandContent", "tooltipPlacement", "gap", "className"]);
  var _e = (0, react_1.useContext)(RadioGroupContext),
    div = _e.expandedRow,
    direction = _e.direction,
    selected = _e.selected,
    setSelected = _e.setSelected,
    groupDisabled = _e.disabled;
  var _f = __read((0, useRandomGuid_1.useRandomGuid)(), 1),
    guid = _f[0];
  var trueInputId = inputId !== null && inputId !== void 0 ? inputId : guid;
  //@ts-ignore
  var onClick = function () {
    return setSelected(value);
  };
  return (0, jsx_runtime_1.jsx)(Popover_1.HoverPopover, __assign({
    content: tooltip,
    disabled: !tooltip,
    tooltip: true,
    interactive: false,
    placement: tooltipPlacement,
    arrow: false
  }, {
    children: (0, jsx_runtime_1.jsxs)(Grid_1.Grid, __assign({
      component: "label",
      align: "center",
      className: (0, classnames_1.default)("vsx-radio-label", className),
      "data-disabled": disabled || groupDisabled,
      htmlFor: trueInputId,
      columnGap: gap,
      rowGap: "medium"
    }, restProps, {
      columns: "auto 1fr"
    }, {
      children: [(0, jsx_runtime_1.jsx)("input", {
        className: "vsx-radio",
        id: trueInputId,
        type: "radio",
        onClick: onClick,
        checked: value === selected,
        disabled: disabled || groupDisabled,
        readOnly: true
      }), (0, jsx_runtime_1.jsx)("span", __assign({
        className: "vsx-radio-label-content"
      }, {
        children: children
      })), details ? (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
        children: [(0, jsx_runtime_1.jsx)("span", {}), (0, jsx_runtime_1.jsx)("span", __assign({
          className: "vsx-radio-details"
        }, {
          children: details
        }))]
      }) : null, (0, jsx_runtime_1.jsx)(RadioExpand, {
        direction: direction,
        selected: value === selected,
        expandContent: expandContent,
        expandedRow: div
      })]
    }))
  }));
};
exports.Radio = Radio;
var RadioExpand = function (_a) {
  var direction = _a.direction,
    selected = _a.selected,
    expandContent = _a.expandContent,
    expandedRow = _a.expandedRow;
  if (!selected || !expandContent) {
    return null;
  }
  var styledExpand = expandContent ? (0, jsx_runtime_1.jsx)("div", __assign({
    className: "vsx-radio-expand"
  }, {
    children: expandContent
  })) : null;
  if (direction === "column") {
    return styledExpand;
  }
  if (direction === "row" && expandedRow) {
    return (0, react_dom_1.createPortal)(styledExpand, expandedRow);
  }
  return null;
};
var RadioGroupContext = (0, react_1.createContext)({
  selected: undefined,
  setSelected: R.N
});